import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Cookies from 'js-cookie';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { UserProfileType } from '@customTypes/user';
import type { UserProfileProviderProps, UserProfileProviderType } from './types';

const Context = createContext({} as UserProfileProviderType);
const useUserProfileContext = (): UserProfileProviderType => useContext(Context);

const UserProfileProvider = ({ children }: UserProfileProviderProps) => {
  const [profile, setProfile] = useState<UserProfileType | null>(null);

  const fetchProfile = useCallback(async () => {
    if (!Cookies.get('accessToken')) return;
    try {
      const { data } = await api.get('/profile/me');
      setProfile(data);
      datadogRum.setUser({ id: data.id, name: data.name, email: data.email });
    } catch {
      // 401 is handled globally by the api interceptor
    }
  }, []);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const value = useMemo(() => ({ profile }), [profile]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export { UserProfileProvider, useUserProfileContext };
